export default __webpack_public_path__ + "static/media/triangle.b43c6e23.svg";